import { AccountStore } from './account/account-store';
import AchievementStore from './achievement/achievement-store';
import { AddOnStore } from './add-on/add-on-store';
import AffiliateCommissionsStore from './affiliation-commissions/affiliation-commissions';
import { ApplicationConfigStore } from './application-config/application-config-store';
import CartStore from './cart/cart-store';
import { ContestStore } from './contest/contest-store';
import { ContestAccountStore } from './contest-account/contest-account-store';
import { ContractStore } from './contract/contract-store';
import { CouponStore } from './coupon/coupon-store';
import { GroupStore } from './group/group-store';
import { MailOtpStore } from './mail-otp/mail-otp-store';
import { PartnerStore } from './partner/partner-store';
import { PaymentSessionStore } from './payment-session/payment-session-store';
import PayoutStore from './payout/payout-store';
import { PositionStore } from './position/position-store';
import { ProgramStore } from './program/program-store';
import PurchaseStore from './purchase/purchase-store';
import RealTimeStore from './real-time/real-time-store';
import { TradeStore } from './trade/trade-store';
import { TradeTalkStore } from './trade-talk/trade-talk-store';
import UserStore from './user/user-store';
import { UsersStore } from './users/users-store';

class DataStore {
  userStore: UserStore;
  usersStore: UsersStore;
  accountStore: AccountStore;
  tradeStore: TradeStore;
  cartStore: CartStore;
  purchaseStore: PurchaseStore;
  couponStore: CouponStore;
  contractStore: ContractStore;
  payoutStore: PayoutStore;
  programStore: ProgramStore;
  groupStore: GroupStore;
  addOnStore: AddOnStore;
  partnerStore: PartnerStore;
  positionStore: PositionStore;
  realTimeStore: RealTimeStore;
  applicationConfigStore: ApplicationConfigStore;
  achievementStore: AchievementStore;
  affiliateCommissionsStore: AffiliateCommissionsStore;
  contestStore: ContestStore;
  contestAccountStore: ContestAccountStore;
  tradeTalkStore: TradeTalkStore;
  mailOtpStore: MailOtpStore;
  paymentSessionStore: PaymentSessionStore;

  constructor() {
    this.userStore = new UserStore();
    this.couponStore = new CouponStore();
    this.contractStore = new ContractStore();
    this.usersStore = new UsersStore();
    this.accountStore = new AccountStore();
    this.tradeStore = new TradeStore();
    this.payoutStore = new PayoutStore();
    this.cartStore = new CartStore();
    this.purchaseStore = new PurchaseStore();
    this.programStore = new ProgramStore();
    this.groupStore = new GroupStore();
    this.partnerStore = new PartnerStore();
    this.addOnStore = new AddOnStore();
    this.positionStore = new PositionStore();
    this.realTimeStore = new RealTimeStore();
    this.applicationConfigStore = new ApplicationConfigStore();
    this.achievementStore = new AchievementStore();
    this.affiliateCommissionsStore = new AffiliateCommissionsStore();
    this.contestStore = new ContestStore();
    this.contestAccountStore = new ContestAccountStore();
    this.tradeTalkStore = new TradeTalkStore();
    this.mailOtpStore = new MailOtpStore();
    this.paymentSessionStore = new PaymentSessionStore();
  }
}

export default DataStore;
